import { useState, useContext, useEffect } from "react";
import { motion } from "framer-motion";
import Footer from "../includes/footer-tab"; // Adjust path
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Preloader from "./Preloader"; // Adjust path
import { useNavigate, Link } from "react-router-dom"; // Import Link
import { AuthContext } from "../context/AuthContext"; // Adjust path
import $ from "jquery"; // Keep jQuery for modal
import Dropdown from "../includes/Dropdown";
import styles from "../assets/css/Mine.module.css"; // Import NEW CSS Module

// Import Icons from react-icons
import {
  FaUserCircle,
  FaWallet,
  FaTrophy,
  FaTimesCircle,
  FaHistory,
  FaListOl,
  FaShareAlt,
  FaYoutube,
  FaWhatsapp,
  FaTelegramPlane,
  FaSignOutAlt,
} from "react-icons/fa";
import { IoMdHelpCircleOutline } from "react-icons/io"; // Help Icon
import { MdDashboard } from "react-icons/md"; // Dashboard Icon

function Mine() {
  const [userid, setUserId] = useState("");
  const [userName, setUserName] = useState("");
  const [preloader, setPreloader] = useState(true);
  const {
    isAuthenticated,
    logout,
    profile,
    WhatsappMessageSupport, // For direct WhatsApp help
    TelegramLink = "https://t.me/pushpendratechnology", // Default Telegram
    YoutubeChannel, // For How to Play
    WhatsappMessage, // For Share function
  } = useContext(AuthContext);
  const navigate = useNavigate();

  // Redirect if not authenticated
  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/login");
    }
  }, [isAuthenticated, navigate]);

  // Toast message function
  const message = (status, text) => {
    const options = {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
    };
    if (status === 1) toast.success(text, options);
    else if (status === 0) toast.error(text, options);
    else if (status === 2) toast.warning(text, options);
  };

  // Fetch profile data
  useEffect(() => {
    let isMounted = true;
    setPreloader(true);
    if (profile) {
      profile((response) => {
        if (!isMounted) return;
        setPreloader(false);
        if (response.status === 0) {
          message(0, response.msg || "Failed to load profile");
        } else if (response.data && response.data.length > 0) {
          setUserId(response.data[0].mobile || "");
          setUserName(response.data[0].name || "User");
        } else {
          message(0, "Profile data not found");
        }
      });
    } else {
      setPreloader(false);
    }
    return () => {
      isMounted = false;
    };
  }, [profile]);

  // Logout handler
  const handleLogout = () => {
    logout();
    // Redirect is handled by useEffect watching isAuthenticated
  };

  // Share handler
  const handleShare = async (event) => {
    event.preventDefault();
    if (!WhatsappMessage) {
      message(0, "Share function not available.");
      return;
    }
    const shareUrl = WhatsappMessage;
    if (shareUrl) {
      window.open(shareUrl, "_blank");
    } else {
      message(0, "Could not generate share link.");
    }
  };

  // Framer Motion variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { staggerChildren: 0.05 } },
  };
  const itemVariants = {
    hidden: { x: -15, opacity: 0 },
    visible: { x: 0, opacity: 1, transition: { type: "tween", duration: 0.3 } },
  };

  // --- Menu Items Data ---
  const menuItems = [
    { name: "Dashboard", icon: <MdDashboard />, url: "/dashboard" },
    {
      name: "Wallet वॉलेट",
      icon: <FaWallet />,
      subItems: [
        { name: "Recharge पैसा जोड़ना", url: "/recharge" },
        { name: "Withdrawal पैसा निकालना", url: "/withdrawal" },
      ],
    },
    { name: "Win History जीता हुआ गेम", icon: <FaTrophy />, url: "/history/win" },
    { name: "Bet History खेला हुआ गेम", icon: <FaHistory />, url: "/history/market" },
    { name: "Kabad Cancel Box कबाड़ कैंसिल बॉक्स", icon: <FaTimesCircle />, url: "/history/marketcancel" }, // Uncomment if needed
    { name: "Game Rate गेम रेट", icon: <FaListOl />, url: "/ratelist" },
    {
      name: "How to Play कैसे खेले गेम",
      icon: <FaYoutube />,
      url: YoutubeChannel,
      isExternal: true,
    }, // External link
    { name: "Share Appऐप शेयर करें", icon: <FaShareAlt />, action: handleShare }, // Action instead of URL
    {
      name: "सहायता (WhatsApp)",
      icon: <FaWhatsapp />,
      url: WhatsappMessageSupport,
      isExternal: true,
    },
    {
      name: "सहायता (Telegram)",
      icon: <FaTelegramPlane />,
      url: TelegramLink,
      isExternal: true,
    },
    { name: "Help मदद / Contact", icon: <IoMdHelpCircleOutline />, url: "/help" }, // Link to your help/contact page
  ];

  return (
    <>
      <Preloader status={preloader} />
      <ToastContainer position="top-right" autoClose={3000} theme="dark" />

      {/* Use the Aghori theme container */}
      <div className={styles.mineContainer}>
        {!preloader && (
          <motion.div
            variants={containerVariants}
            initial="hidden"
            animate="visible"
            exit={{ opacity: 0 }}
          >
            {/* --- Header Section --- */}
            <motion.div className={styles.mineHeader} variants={itemVariants}>
              <div className={styles.profileImage}>
                <FaUserCircle />
              </div>
              <div className={styles.profileInfo}>
                <p className={styles.profileName}>{userName}</p>
                <p className={styles.profileId}>ID: {"+91" + userid}</p>
              </div>
            </motion.div>

            {/* --- List of Options --- */}
            <motion.div className={styles.optionsList}>
              {menuItems.map((item, index) => (
                <motion.div key={index} variants={itemVariants}>
                  {item.subItems ? (
                    <Dropdown
                      key={index} // Add key here
                      icon={item.icon}
                      name={item.name}
                      menu={item.subItems}
                      // Pass Mine styles as props
                      triggerClassName={styles.optionItem}
                      iconClassName={styles.optionIcon}
                      nameClassName={styles.optionName}
                      arrowClassName={styles.optionArrow}
                    />
                  ) : item.action ? (
                    // Render as a button for actions
                    <button onClick={item.action} className={styles.optionItem}>
                      <span className={styles.optionIcon}>{item.icon}</span>
                      <span className={styles.optionName}>{item.name}</span>
                      <span className={styles.optionArrow}>&gt;</span>
                    </button>
                  ) : item.isExternal ? (
                    // Render as an anchor tag for external links
                    <a
                      href={item.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={styles.optionItem}
                    >
                      <span className={styles.optionIcon}>{item.icon}</span>
                      <span className={styles.optionName}>{item.name}</span>
                      <span className={styles.optionArrow}>&gt;</span>
                    </a>
                  ) : (
                    // Render as a Link for internal navigation
                    <Link to={item.url} className={styles.optionItem}>
                      <span className={styles.optionIcon}>{item.icon}</span>
                      <span className={styles.optionName}>{item.name}</span>
                      <span className={styles.optionArrow}>&gt;</span>
                    </Link>
                  )}
                </motion.div>
              ))}

              {/* Logout Button */}
              <motion.div
                className={styles.logoutButtonContainer}
                variants={itemVariants}
              >
                <button
                  className={styles.logoutButton}
                  onClick={() => {
                    $(".logout-modal.modal").addClass("active");
                  }}
                >
                  <FaSignOutAlt /> Logout
                </button>
              </motion.div>
            </motion.div>
          </motion.div>
        )}
      </div>

      {/* --- Logout Modal (Keep structure, style via CSS) --- */}
      <section className={`${styles.logoutModal} logout-modal modal`}>
        <div className={styles.modalSection}>
          <p className={styles.modalTitle}>Confirm Logout</p>
          <p className={styles.modalText}>Do you want to continue?</p>
          <div className={styles.modalBtnContainer}>
            <div className={styles.modalActionBtn}>
              <div
                onClick={() => {
                  $(".logout-modal.modal").removeClass("active");
                }}
                className={styles.modalCancelBtn}
              >
                CANCEL
              </div>
              <div onClick={handleLogout} className={styles.modalConfirmBtn}>
                YES
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* --- Footer --- */}
      <Footer />
    </>
  );
}

export default Mine;
